// ante-react-kit/src/components/v2/AntHeaderCard/PickerDisplay.js
// Read-only display cho sections có picker (entity, address).
// Chỉ hiện data đã nhập dạng text. Nhập liệu qua picker popup.
import React, { useMemo } from 'react';
import AntLocalization from '../../../utils/AntLocalization';
import AntConfig from '../../../utils/AntConfig';
import { AntGlobal } from '../../../utils/AntContext';

export default function PickerDisplay(props) {
    var { fields, formData, table, emptyText, onPickerClick } = props;
    var appGlobal = AntGlobal();

    // Load labels from AntConfig
    var labelMap = useMemo(function () {
        var map = {};
        if (table && appGlobal) {
            var config = new AntConfig(appGlobal, table);
            var cnfFields = config.loadFields(table);
            if (cnfFields && cnfFields.length > 0) {
                cnfFields.forEach(function (cnf) {
                    if (cnf.dataField && cnf.label) {
                        map[cnf.dataField] = AntLocalization.translateText(cnf.label);
                    }
                });
            }
        }
        return map;
    }, [table, appGlobal]);

    // Collect non-empty fields
    var displayItems = useMemo(function () {
        if (!fields || !formData) return [];
        return fields
            .filter(function (f) {
                var val = formData[f];
                return val !== null && val !== undefined && val !== '';
            })
            .map(function (f) {
                return { field: f, label: labelMap[f] || f, value: formData[f] };
            });
    }, [fields, formData, labelMap]);

    if (displayItems.length === 0) {
        // No data — show empty state with click-to-pick
        var translatedEmpty = emptyText ? AntLocalization.translateText(emptyText) : AntLocalization.translateText({ vi: 'Chưa có thông tin', en: 'No data', fr: 'Aucune info', es: 'Sin datos', id: 'Belum ada info', ja: '情報なし', zh: '暂无信息', ko: '정보 없음', hi: 'कोई जानकारी नहीं', ar: 'لا توجد بيانات' });
        return (
            <div className="v2-picker-display v2-picker-display--empty" onClick={onPickerClick}>
                <span className="v2-picker-display__empty-text">
                    {translatedEmpty}
                </span>
                <span className="v2-picker-display__empty-hint">
                    {AntLocalization.translateText({ vi: 'Nhấn để chọn', en: 'Click to select', fr: 'Clic pour choisir', es: 'Clic para elegir', id: 'Klik untuk memilih', ja: 'クリックして選択', zh: '点击选择', ko: '클릭하여 선택', hi: 'चुनने हेतु क्लिक', ar: 'انقر للاختيار' })}
                </span>
            </div>
        );
    }

    return (
        <div className="v2-picker-display" onClick={onPickerClick}>
            {displayItems.map(function (item) {
                return (
                    <div key={item.field} className="v2-picker-display__row">
                        <span className="v2-picker-display__label">{item.label}</span>
                        <span className="v2-picker-display__value">{String(item.value)}</span>
                    </div>
                );
            })}
        </div>
    );
}
